import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SupplierRequestApiService {
  private readonly httpClient = inject(HttpClient);

  getSupplierRequest(key: string, newFormSchema = false) {
    let url = `/api/v1/supplier/request/${key}`;

    if (newFormSchema) {
      url = `${url}?get_new_formschema=${newFormSchema}`;
    }

    return this.httpClient.get(url);
  }

  submitRequestData(rid, status, payload = {}) {
    rid = rid.replace('#', '');
    return this.httpClient.put(`/api/v1/supplier/request/${rid}/status/${status}`, payload);
  }

}
